import React from 'react';

interface SkillStampProps {
  result?: {
    program_skills_abhs?: number;
    program_skills_abhs_mod2?: number;
    program_skills_pom_straps: number;
  };
}

const SkillStamps: React.FC<SkillStampProps> = ({ result }) => {

  if (!result?.program_skills_abhs && !result?.program_skills_abhs_mod2 && !result?.program_skills_pom_straps) {
    return null;
  }

return (
  <div className='skill-stamp-wrapper'>
    <span className="skill-stamp-spacer"></span>
    {result.program_skills_abhs === 1 && (
      <>
        <img
          src="/images/ABHS-logo.png"
          alt="ABHS"
          className="skill-stamps"
        />
        <span className="skill-stamp-spacer"></span>
      </>
    )}
    {result.program_skills_abhs_mod2 === 1 && (
      <>
      <img
        src="/images/ABHS-module2-logo.png"
        alt="ABHS MOD2"
        className="skill-stamps"
      />
      <span className="skill-stamp-spacer"></span>
      </>
    )}
    {result.program_skills_pom_straps === 1 && (
      <img
        src="/images/pom-straps-logo.png"
        alt="POM STRAPS"
        className="skill-stamps"
      />
    )}
  </div>
);
};

export default SkillStamps;